<ion-content>
  <usucampeao-notificacoes-detalhes *ngIf="notificacao$ | async; let notificacao" [notificacao]="notificacao"
    [cadastro]="cadastro">
  </usucampeao-notificacoes-detalhes>
</ion-content>
